<template>
  <div>
    <modal v-if="password" xsmall @close="password = false" class="save">
      <div slot="body">
        <div class="p-5 text-center">
          <h2>{{ $t('payment.customer.title_forgotten_password') }}</h2>
          <h4 v-if="!changed">{{ $t('payment.customer.request_forgotten_password') }}</h4>
          <div class="input-group mt-4" v-if="!changed">
            <input 
              type="email" 
              class="form-control"
              :class="{ 'border-danger' : emailError }"
              v-model="email"
              :placeholder="$t('airportparking.results.product.email_address')" 
              :aria-label="$t('airportparking.results.product.email_address')"
            />
            <div class="input-group-append">
              <button class="btn btn-secondary" @click="request" type="button">{{ $t('payment.customer.request') }}</button>
            </div>
            <p v-if="changeError" class="mt-3 text-center w-100">{{ $t('payment.customer.password_change.error') }}</p>
          </div>
          <div v-else>
            <h4>{{ $t('payment.customer.password_change.email_sent') }}</h4>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { sync, call, get } from "vuex-pathify";
import mixins from "@/mixins";
import { Modal } from "@/components";

export default {
  name: "save",
  mixins: [mixins.load, mixins.validate],
  components: { Modal },
  data() {
    return {
      email: '',
      emailError: false,
      changeError: false,
    }
  },
  computed: {
    password: sync("modals/passwordReset"),
    changed: get("customer/passwordChanged")
  },
  methods: {
    forgottenPassword: call("customer/forgottenPassword"),
    request() {
      if(this.validEmail(this.email)) {

        this.emailError = false;

        this.forgottenPassword(this.email).then(() => {
          if(!this.changed) this.changeError = true; 
        })

      } else {
        this.emailError = true;
      }
    }
  }
};
</script>